function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("filter", {
  id: "f2",
  height: 180,
  width: 180,
  x: -50,
  y: -50
},
/*#__PURE__*/
React.createElement("feDropShadow", {
  dx: 0.8,
  dy: 0.8,
  stdDeviation: 5,
  floodColor: "currentColor",
  floodOpacity: 0.5
}));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Metha Token");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Capa_2",
  "data-name": "Capa 2"
},
/*#__PURE__*/
React.createElement("g", {
  id: "Capa_1-2",
  "data-name": "Capa 1"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M39,74.25h0Z",
  transform: "translate(-0.25 -0.25)"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M.32,35.08v4.48A37.2,37.2,0,0,1,.32,35.08Z",
  transform: "translate(-0.25 -0.25)"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M74.33,37.3A37,37,0,0,1,69.7,55.22a45.17,45.17,0,0,1-2.64,4.1,39.47,39.47,0,0,1-8,7.86,35.88,35.88,0,0,1-5.67,3.42c-6.77,3.45-13.7,3.49-14.44,3.65h-3.4l-4-.45A36.91,36.91,0,0,1,.32,39.56V35.08A36.77,36.77,0,0,1,3.51,22.17a38.14,38.14,0,0,1,6.2-9.62,36.75,36.75,0,0,1,6-5.35A37.14,37.14,0,0,1,28,1.43c1.23-.3,2.42-.56,3.74-.76l4-.42H39c.16.08,3.49.36,4.06.44a38.15,38.15,0,0,1,10.37,3.2,35.22,35.22,0,0,1,6.89,4.34l1.24,1c.83.74,1.57,1.5,2.33,2.27A37,37,0,0,1,74.33,37.3ZM59.48,60a31.79,31.79,0,0,0,6.81-35.79,33.1,33.1,0,0,0-4.11-6.7,34.87,34.87,0,0,0-2.57-2.87c-1-1-5-4.34-6.17-4.66a29.55,29.55,0,0,1-3.09,3.14,18.6,18.6,0,0,0-1.65,1.46l-7.17,5.32c-2.14,1.49-5.48,3.67-7.4,5.11l-2.74,2a42.22,42.22,0,0,0-4.33,3.56,6.54,6.54,0,0,0-1.34,1.87H48.61C48,31.15,44.79,28.06,43.7,27c-.28-.27-.55-.42-.67-.84.17-.27,0,0,.22-.23a48.35,48.35,0,0,1,4.18-3.08,19,19,0,0,1,3,2.88,3.42,3.42,0,0,0,.42.43c4.21,4.13,7.21,11,3.69,16.84A21.91,21.91,0,0,1,52.47,46l-.39.46a19.38,19.38,0,0,1-2,2.24c-.62.62-3.27,3.08-4.07,3.64L44.58,53.5A13,13,0,0,0,42.69,55c.86.75,1.85,1.51,2.72,2.26l.7.59c1.41,1.14,3.29,2.93,4.74,4.23a33,33,0,0,0,2.63,2.53A40.88,40.88,0,0,0,59.48,60ZM50.11,39.85a6.25,6.25,0,0,0,.32-4c-.24-.77-.38-1.22-.86-1.22H24.48A12.31,12.31,0,0,0,24,36.71c0,2.14.4,1.86.64,3.14Zm-1.19,2.21H26.06L28,44.51a50.67,50.67,0,0,1,3.64,3.83,1.28,1.28,0,0,1-.5.45c-.82.55-3.39,2.63-3.86,2.87a26.28,26.28,0,0,1-2.94-2.74,28.13,28.13,0,0,1-2.6-3.07,23.63,23.63,0,0,1-2.09-3.57,11,11,0,0,1-.43-8.73,17,17,0,0,1,1.24-2.62c.23-.41.48-.79.74-1.18s.55-.69.84-1.09a43.09,43.09,0,0,1,5.73-5.81L32,19.49l-5.5-4.63c-1.48-1.36-4.06-3.69-5.25-5a29.88,29.88,0,0,0-4.66,3.4A39.19,39.19,0,0,0,12.06,18,32.67,32.67,0,0,0,5.5,37.14a32,32,0,0,0,5.26,17.55,30.26,30.26,0,0,0,3,3.77c1.08,1.08.18.52,2,2l3.72,3a7.08,7.08,0,0,0,1.77,1.07,47.48,47.48,0,0,1,7.35-6.67c.34-.26.61-.42.93-.68a19.08,19.08,0,0,1,1.79-1.31L36.88,52c1.53-1,4.94-3.35,6.4-4.49,1.29-1,4.2-3.24,5-4.48A3,3,0,0,0,48.92,42.06ZM47.48,67.33l.26-.14a19.88,19.88,0,0,0-1.61-1.57c-.83-.8-.61-1.06-2.21-1.06h-13c-2,0-1.6-.23-2.49.66a3.46,3.46,0,0,0-1.18,2.14,31.4,31.4,0,0,0,20,.06A.92.92,0,0,0,47.48,67.33Zm-1.27-58a4.24,4.24,0,0,0,1.15-2.13c-1.06-.87-7.62-1.75-9.58-1.75A32.51,32.51,0,0,0,31.55,6l-3.61.88-.56.18-.48.26a13.6,13.6,0,0,0,1.61,1.61c.77.77.63,1,2.14,1h13C45.23,9.92,45.34,10.2,46.21,9.32Zm-3.72,2.85H32.37A28.88,28.88,0,0,0,36.06,15c.31.21,1,.87,1.32.78.16,0,2.39-1.59,2.61-1.75C40.85,13.45,41.69,12.83,42.49,12.17ZM32.11,62.31H42.26c-.15-.41-2.92-2.33-3.53-2.79a12,12,0,0,0-1.34-.89c-.82.41-1.85,1.28-2.67,1.81-.48.31-.87.62-1.33.91Z",
  transform: "translate(-0.25 -0.25)"
})));

var SvgLogoMetha = function SvgLogoMetha(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      viewBox: "0 0 74.08 74.01",
      ref: svgRef
    }, props), _ref2, title === undefined ? _ref3 : title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref4)
  );
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgLogoMetha, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/logo-metha.c495ee7f.svg";
export { ForwardRef as ReactComponent };